import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '~common/service/authentication.service'
import { NotificationService } from '~common/service/notification.service'
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isCollapsed = false;
  date = new Date();
  userProfile: any;
  notificationList: Array<any>
  notificationTotal=0
  @Output() buka :EventEmitter<null> = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService, private notificationService:NotificationService, private msalService: MsalService) { }

  ngOnInit() {
    this.userProfile = this.authService.getProfile();
    this.getNotifications()
  }

  logout() {
    this.msalService.logout();
    localStorage.clear();
    // this.router.navigate(['/login']);
  }

  bukaDrawer(){
    if(this.isCollapsed){
      this.isCollapsed = false
    }else{
      this.isCollapsed = true
    }
    this.buka.emit();
  }

  getNotifications(){
    let query = '?s=10'
    this.notificationService.getNotifications(query).then(result=>{
      if(result.isSuccess){
        this.notificationList = result.payload
        this.notificationTotal = result.payload.length
      }
    })
  }

  detailNotification(notification){
    this.notificationService.readNotification(notification.id).then(()=>{
      if(notification.url!=''){
        this.getNotifications()
        window.location.href=notification.url
      }
    })
  }
}
